<template>
  <div class="debt-fields">
    <div>
      <div class="inputs-title-text">
        <span class="title-text is-size-6 has-text-weight-semibold">Deuda Largo plazo</span>
        <span class="title-comment is-size-7">según SBIF</span>
      </div>
      <BaseInput
        id="long-term-debt-balance"
        :value="inputs.longTermDebt"
        type="number"
        :format-type="'currencyNumber'"
        :placeholder="'Monto'"
        :icon="'a-solid fa-dollar-sign'"
        @input="value => updateInputs(value, 'longTermDebt')" />
    </div>
    <div>
      <div class="inputs-title-text">
        <span class="title-text is-size-6 has-text-weight-semibold">Deuda Corto plazo</span>
        <span class="title-comment is-size-7">según SBIF</span>
      </div>
      <BaseInput
        id="short-term-debt-balance"
        :value="value.shortTermDebt"
        type="number"
        :format-type="'currencyNumber'"
        :placeholder="'Monto'"
        :icon="'a-solid fa-dollar-sign'"
        @input="value => updateInputs(value, 'shortTermDebt')" />
    </div>
    <div class="debt-field">
      <div class="inputs-title">
        <span class="title-text is-size-6 has-text-weight-semibold">Agregar Deuda Acreditada</span>
        <a id="add-debt-button" href="#" @click="$emit('add-input', { debtorIndex, type: 'debt', gloss: 'accreditedDebts'})">
          <span class="fa fa-plus-circle" />
        </a>
      </div>
      <div v-for="(accreditedDebt, i) in inputs.accreditedDebts" :key="i" class="gloss-value">
        <a
          :id="`debt-${i}-delete-button`"
          href="#"
          @click.prevent="$emit(
            'delete-input',
            { debtorIndex, type: 'debt', gloss: 'accreditedDebts', inputIndex: i }
          )">
          <i class="fa-solid fa-trash-can" />
        </a>
        <div class="b-field-inputs">
          <div v-for="(field, fieldName) in accreditedDebtsFields" :key="fieldName" class="b-field-input">
            <BaseInput
              :id="`debt-${i}-${fieldName}`"
              :value="value.accreditedDebts[i][fieldName]"
              :title="field.title"
              :term-type="inputs.accreditedDebts[i].termType"
              :self-term-type="field.selfTermType"
              :type="field.type"
              :format-type="field.formatType"
              :placeholder="field.placeholder"
              :options="field.options"
              :icon="field.icon"
              @input="value => updateInputs(value, 'accreditedDebts', i, fieldName)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInput from '@/ui/components/internal/risk-evaluation/BaseInput.vue';

export default {
  name: 'DebtInputs',
  components: { BaseInput },
  props: {
    value: { type: Object },
    debtorIndex: Number
  },
  data() {
    return {
      inputs: {},
      accreditedDebtsFields: {
        description: {
          title: 'Descripción',
          type: 'text',
          formatType: 'text',
          placeholder: ''
        },
        termType: {
          type: 'select',
          placeholder: 'Plazo',
          title: 'Plazo',
          options: [
            { value: 'LONG_TERM', label: 'Largo' },
            { value: 'SHORT_TERM', label: 'Corto' }
          ]
        },
        isInvestment: {
          type: 'switch',
          selfTermType: 'LONG_TERM',
          placeholder: 'Inversión'
        },
        isLiquidation: {
          type: 'switch',
          selfTermType: 'SHORT_TERM',
          placeholder: 'Liquidación'
        },
        balance: {
          title: 'Saldo Insoluto',
          type: 'number',
          formatType: 'currencyNumber',
          placeholder: 'Monto',
          icon: 'a-solid fa-dollar-sign'
        },
        monthlyPayment: {
          title: 'Cuota mensual',
          type: 'number',
          formatType: 'currencyNumber',
          placeholder: 'Monto',
          icon: 'a-solid fa-dollar-sign'
        }
      }
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(vModelValues) {
        this.inputs = vModelValues;
      }
    }
  },
  methods: {
    updateInputs(value, gloss, glossIndex, fieldName) {
      const updated = JSON.parse(JSON.stringify(this.inputs));
      if (gloss !== 'accreditedDebts') {
        updated[gloss] = value;
      } else {
        updated[gloss][glossIndex][fieldName] = value;
      }
      this.$emit('input', updated);
    }
  }
};
</script>

<style scoped>

.gloss-value {
  display: flex;
  align-items: center;
  gap: 1rem 1rem;
}
.debt-fields {
  display: flex;
  flex-flow: column wrap;
  gap: 2rem;
}
.debt-field {
  display: flex;
  flex-flow: column wrap;
  gap: 2rem;
}
.inputs-title-text {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 0rem 1rem;
}
.inputs-title {
  display: grid;
  grid-template-columns: 1fr 1rem;
  align-items: center;
}
.b-field-inputs {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 1rem 1rem;
}
.b-field-input {
  flex-grow: 1;
}
</style>
